/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateEnrollmentDto } from '../../models/create-enrollment-dto';
import { EnrollmentDto } from '../../models/enrollment-dto';

export interface EnrollmentControllerCreate$Params {
      body: CreateEnrollmentDto
}

export function enrollmentControllerCreate(http: HttpClient, rootUrl: string, params: EnrollmentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrollmentDto>> {
  const rb = new RequestBuilder(rootUrl, enrollmentControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnrollmentDto>;
    })
  );
}

enrollmentControllerCreate.PATH = '/api/enrollment';
